import {useDisclosure} from '@mantine/hooks';
import {MdBookmark} from 'react-icons/md';
import {useAuth} from '../../../../../core/usecases/useAuth';
import {cn} from '../../../../../lib/classname';
import {NoLoginAlertModal} from '../../../../../shared/components/NoLoginAlertModal';

type Props = {
  isClipped: boolean;
  handleClip: () => Promise<void>;
  count: number;
};

export const Clip: React.FC<Props> = ({isClipped, handleClip, count}) => {
  const {isSignedIn} = useAuth();
  const [opened, {open, close}] = useDisclosure(false);

  const handleUpdate = async () => {
    if (!isSignedIn) {
      open();
      return;
    }

    await handleClip();
  };

  return (
    <>
      <button
        className={cn(
          'h-[36px] pc:h-[44px] px-12 py-6 rounded-[28px] border-2 border-primary-1 text-primary inline-flex justify-center items-center gap-[6px]',
          isClipped && 'bg-primary-1 text-white',
        )}
        type="button"
        onClick={handleUpdate}
      >
        <MdBookmark
          size={20}
          className={cn('text-primary-1', isClipped && 'text-white')}
        />
        <span className="text-[12px]">クリップ</span>
        <span className="hidden pc:inline-block text-[12px]">{count}</span>
      </button>
      <NoLoginAlertModal opened={opened} onClose={close} />
    </>
  );
};
